import { CSSProperties, useEffect, useRef, useState } from 'react';

interface iCustomImageHandlerProps {
    photoPath: string | null | undefined;
    thumbnailPath?: string;
    altTag: string;
    name?: string;
    displayName?: string;
    classes?: string;
    placeholder?: string;
    style?: CSSProperties;
    onClick?: () => void;
    isSquare?: boolean;
    removeLh?: boolean;
    h100?: boolean;
}

export const CustomImageHandler = ({
    thumbnailPath,
    photoPath,
    altTag,
    name,
    classes = '',
    style,
    onClick,
    placeholder = '/icons/img-missImg.png',
    isSquare,
    removeLh,
    h100,
}: iCustomImageHandlerProps) => {
    const [loaded, setLoaded] = useState(!thumbnailPath);

    const handleLoad = () => {
        setLoaded(true);
    };
    const isUserImage = classes?.includes('user-img-rounded') || altTag?.includes('User Profile');
    const initial = name?.trim()?.charAt(0)?.toUpperCase();
    const hasImage = !!photoPath || !!thumbnailPath;
    const showAvatar = isUserImage && !hasImage && !!initial;
    const showDefaultSvg = isUserImage && !hasImage && !initial;
    const errorImageCheck = showDefaultSvg ? '/tempAssets/userLargePlaceholder.svg' : placeholder;
    const avatarRef = useRef<HTMLDivElement>(null);
    const [fontSize, setFontSize] = useState(18);

    useEffect(() => {
        if (!avatarRef.current) return;

        const observer = new ResizeObserver(entries => {
            const size = entries[0].contentRect.width;
            const multiplier = isSquare ? 0.46 : 0.6;
            setFontSize(Math.round(size * multiplier));
        });

        observer.observe(avatarRef.current);

        return () => observer.disconnect();
    }, [initial]);
    return (
        <>
            {showAvatar ? (
                <div
                    onClick={onClick}
                    className={classes}
                    ref={avatarRef}
                    style={{
                        // width: '50px',
                        // height: '50px',
                        borderRadius: `${isSquare ? '7px' : '50px'}`,
                        backgroundColor: '#F3F6F9',
                        color: '#9EA5AB',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: `${fontSize > 30 ? 400 : 500}`,
                        userSelect: 'none',
                        flexShrink: 0,
                        height: h100 ? '100%' : undefined,
                        ...style,
                    }}
                >
                    <span
                        style={{
                            fontSize: `${fontSize}px`,
                            lineHeight: `${!removeLh && 1}`,
                            color: '#9EA5AB',
                            padding: 0,
                            marginBottom: 0,
                        }}
                    >
                        {initial}
                    </span>
                </div>
            ) : (
                <>
                    {!loaded && thumbnailPath && (
                        <img
                            src={thumbnailPath}
                            alt={altTag}
                            onClick={onClick}
                            style={style}
                            onError={(e: any) => {
                                e.target.onerror = null;
                                e.target.src = isUserImage
                                    ? '/tempAssets/userLargePlaceholder.svg'
                                    : '/icons/img-missImg.png';
                            }}
                            className={`thumbnail-image ${classes}`}
                        />
                    )}

                    <img
                        src={photoPath || errorImageCheck}
                        alt={altTag}
                        style={style}
                        onClick={onClick}
                        className={`${!loaded ? 'd-none' : ''} ${classes}`}
                        onLoad={handleLoad}
                        onError={(e: any) => {
                            e.target.onerror = null;
                            e.target.src = isUserImage
                                ? '/tempAssets/userLargePlaceholder.svg'
                                : '/icons/img-missImg.png';
                        }}
                    />
                </>
            )}
        </>
    );
};
